<div class="addDialog">
  <!--<div class="addDialog__close" (click)="closeAddDialog()">X</div>-->
  <div class="addDialog__1stContainer">
    {{ 'EXERCISES.EDITOR.addDialogHeader' | translate }}
  </div>
  <div class="addDialog__2ndContainer">
    <app-box class="addDialog__2ndContainer__item"
             [boxType]="'new'"
             [type]="'add'"
             [title]="'EXERCISES.newProgram' | translate"
             (onSelect)="addToProgram()">
    </app-box>
    <app-box class="addDialog__2ndContainer__item" *ngFor="let fav of favs"
             [boxType]="'mp'"
             [type]="'add'"
             [preview]="fav.previewUrl"
             [title]="fav.title"
             [num]="fav.exerciseIds.length"
             (onSelect)="addToProgram(fav)"
             [hideButtons]="true">

    </app-box>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/add-dialog/add-dialog.component.html